import { FormsService } from "./../../../services/forms/forms.service";

import { ChangeNotificationSettingsActionType } from "./../types";
import { getChangedFormNotificationSettings } from "./../../../helpers/dataManipulations";

export function* changeNotificationsSettingsSaga({ payload }: ChangeNotificationSettingsActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormNotificationSettings(payload.currentState),
        });
    } catch (error) {
        // yield put(Handle Error);
    }
}
